<template>
    <div>
        <Form class="form">
            <div class="title">
                <div class="left">联动名称</div>
            </div>
            <Field
                    v-model="detail.name"
                    rows="2"
                    autosize
                    type="textarea"
                    maxlength="40"
                    placeholder="请输入联动名称，未填写将会自动生成。"
                    show-word-limit
            />
            <div class="title">
                <div class="left">如果</div>
                <div class="right">左滑操作</div>
            </div>
            <div v-if="detail.linkageTriggerList.length !== 0" >
                <SwipeCell 
                    :right-width="120" 
                    v-for="(item,index) in detail.linkageTriggerList"
                    v-show="!item.isDelete"
                    :key="index">
                    <div class="main-device-item bg-write">
                        <div class="flex-center-y title">
                            {{item.eventName||'未选择事件'}}
                        </div>
                        <div class="flex-center-y  device-info">
                            <img :src="getImgUrl(item.productImage1)"/>
                            <div class="right">
                                <div class="device-name">
                                    {{item.deviceName}}({{item.deviceSn}})
                                </div>
                                <div class="product-name">
                                    {{item.productName}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <template #right>
                        <Button type="primary" style="height: 100%" @click="eventVisible=true">编辑</Button>
                        <Button type="danger" style="height: 100%"  @click="deleteTrigger(index)">
                            删除
                        </Button>
                    </template>
                </SwipeCell>
            </div>
            <div class="main-device-item bg-write" @click="addMainDevice">
                <div class="flex-center-y  device-info">
                    <img src="./style/add.png"/>
                    <div class="right">
                        添加条件
                    </div>
                </div>
            </div>
            <div class="title">
                <div class="left">就执行</div>
                <div class="right">左滑操作</div>
            </div>
            <SwipeCell
                    v-for="(item,index) in detail.linkageExecuteList"
                    v-show="!item.isDelete"
                    :right-width="120"
                    :key="index">
                <div class="main-device-item bg-write">
                    <div class="flex-center-y action-name">
                        {{item.actionName||'未选择操作'}}
                    </div>
                    <div class="flex-center-y  device-info">
                        <img :src="getImgUrl(item.productImage1)"/>
                        <div class="right">
                            <div class="device-name">
                                {{item.deviceName}}({{item.deviceSn}})
                            </div>
                            <div class="product-name">
                                {{item.productName}}
                            </div>
                        </div>
                    </div>
                </div>
                <template #right>
                    <div style="height: 100%;">
                        <Button type="primary" style="height: 100%" @click="editExecute(index)">
                            编辑
                        </Button>
                        <Button type="danger" style="height: 100%" @click="deleteExecute(index)">删除</Button>
                    </div>
                </template>
            </SwipeCell>
            <div class="flex-center-x add-execute"
                 @click="deviceVisible=true,index=0">
                <WeChatIcon name="add"/>
                <span>添加执行动作</span>
            </div>
            <pf code="LINKAGE_EDIT">
                <Button type="info" block style="width: 95% ; margin: 10px auto;" @click="submit">保存</Button>
            </pf>

            <pf code="LINKAGE_DELETE">
                <Button v-if="linkageId" type="danger" block style="width: 95% ; margin: 10px auto;" @click="onDelete">
                    删除
                </Button>
            </pf>
        </Form>
        <SelectDevicePopup :show="deviceVisible"
                           @ok="onSelectDevice" @cancel="deviceVisible=false"/>
        <SelectDeviceEventPopup :show="eventVisible" :deviceId="detail.deviceId"
                                @ok="onSelectEvent" @cancel="eventVisible=false"/>
        <SelectActionPopup :show="actionVisible"
                           :actionList="actionList"
                           :selectAction="getSelectAction"
                           :defaultValue="getActionDefaultValue"
                           :deviceId="getDeviceId"
                           @ok="onSelectAction" @cancel="actionVisible=false"/>
    </div>
</template>

<script>
    import {Button, Cell, Dialog, Field, Form, SwipeCell} from "vant";
    import WeChatIcon from "@/components/Icon/WeChatIcon"
    import SelectDevicePopup from "@/components/SelectPopup/SelectDevicePopup"
    import SelectDeviceEventPopup from "@/components/SelectPopup/SelectDeviceEventPopup"
    import SelectActionPopup from "@/components/SelectPopup/SelectActionPopup"
    import {downloadImg} from "@/config"


    export default {
        components: {
            Form, Field, Button, Cell, SwipeCell, WeChatIcon,
            SelectDevicePopup, SelectDeviceEventPopup, SelectActionPopup
        },
        props: {},
        data() {
            return {
                index: -1,// -1  操作如果设备  >=0  操作就执行设备
                linkageId: this.$route.params.id,
                detail: {
                    name: '',
                    enable: true,
                    executeList: [],
                    //新
                    executeDay:true,
                    executeDayEnd:'00:00',
                    executeDayStart:'00:00',
                    executeRepeatCron:null,
                    linkageExecuteList:[],
                    linkageTriggerList:[],
                    unitId:'',
                    unitName:''
                },
                actionMap: {},
                actionList: [],
                deviceVisible: false,
                eventVisible: false,
                actionVisible: false,
            }
        },
        computed: {
            getDeviceId() {
                const {index} = this;
                if (index >= 0) {
                    const {executeList} = this.detail
                    const {deviceId} = executeList[index] || {}
                    return deviceId
                }
                return ''
            },
            getSelectAction() {
                const {index} = this;
                if (index >= 0) {
                    const {executeList} = this.detail
                    const {actionCode} = executeList[index] || {}
                    return actionCode
                }
                return ''
            },
            getActionDefaultValue() {
                const {index} = this;
                if (index >= 0) {
                    const {executeList} = this.detail
                    const {params} = executeList[index] || {params: {}}
                    return params
                }
                return {}
            },
        },
        created() {
        },
        mounted() {
            if (this.linkageId != null) {
                this.getDetail();
            }
        },
        methods: {

            getDetail() {
                this.$http.tokiot.linkageRules.get({id: this.linkageId})
                    .then(res => {
                        if (res) {
                            res.linkageExecuteList.map(item => item.params = JSON.parse(item.actionParams))
                            this.detail = res;
                            console.info('this.detail',this.detail)
                        }
                    })
            },
            getImgUrl(url) {
                return downloadImg + url
            },
            addMainDevice(device) {
                this.index = -1;
                this.deviceVisible = true
                // 选择设备
            },
            //删除如果设备
            deleteTrigger(index) {
                const {linkageTriggerList} = this.detail
                this.$delete(linkageTriggerList, index)
            },
            //删除就执行设备
            deleteExecute(index) {
                const {linkageExecuteList} = this.detail
                this.$delete(linkageExecuteList, index)
            },
            editExecute(index) {
                this.index = index
                this.actionVisible = true
                // 打开选择操作
            },
            onSelectDevice(device) {
                const {id, sn, name, productName, productImage1} = device
                const source = {
                    deviceId: id, deviceSn: sn, deviceName: name,
                    productName, productImage1
                }
                let target;
                console.info('未添加如果设备',target)
                if (-1 == this.index) {
                    // 如果设备
                    target = this.detail
                    console.info('添加如果设备',target)
                    console.info('添加如果设备',this.detail)
                    Object.keys(source).map(key => {
                        target[key] = source[key]
                    })
                    delete this.detail.eventCode
                    delete this.detail.eventName
                    delete this.detail.eventId
                    this.eventVisible = true
                } else {
                    // 就执行设备
                    const {executeList} = this.detail
                    this.index = executeList.push(source) - 1
                    // 获取操作列表
                    this.loadActionList(id)
                    // 选择需要操作
                    this.actionVisible = true
                }
                this.deviceVisible = false
            },
            onSelectEvent(event) {
                this.detail.eventCode = event.code;
                this.detail.eventName = event.name;
                this.detail.eventId = event.id;
                this.eventVisible = false
            },
            onSelectAction(action, params) {
                const execute = this.detail.executeList[this.index];
                execute.actionCode = action.code
                execute.actionName = action.name
                execute.params = params
                this.actionVisible = false
            },
            loadActionList(deviceId) {
                this.$http.tokiot.device.product.action.list({id: deviceId})
                    .then(actionList => {
                        if (actionList) {
                            actionList.map(item => item.paramList = JSON.parse(item.inputParams))
                            this.actionMap[deviceId] = actionList
                            this.actionList = actionList
                        }
                    })
            },
            generateName() {
                const {detail} = this
                if (detail.name) return true
                this.detail.name = `${detail.deviceName}${detail.eventName}-${detail.executeList[0].deviceName}${detail.executeList[0].actionName}`
                return true
            },
            verfication() {
                const {detail} = this
                const {executeList} = detail
                if (!detail.deviceId) {
                    this.$toast.fail('请选择如果设备');
                    return false
                } else if (!detail.eventCode) {
                    this.$toast.fail('请选择如果设备触发条件');
                    return false
                } else if (!executeList.length) {
                    this.$toast.fail('请至少设置一个就执行动作');
                    return false
                } else {
                    let execute = {}
                    for (let index = 0; index < executeList.length; index++) {
                        execute = executeList[index]
                        if (!execute.deviceId) {
                            this.$toast.fail('就执行动作未选择设备');
                            return false
                        } else if (!execute.actionCode) {
                            this.$toast.fail(`${execute.deviceName}未选择操作`);
                            return false
                        }
                    }

                }

                return true
            },
            submit() {
                if (!(this.verfication() && this.generateName())) return;
                if (this.linkageId) {
                    this.$http.tokiot.linkage.update(this.detail)
                        .then(ret => {
                            if (ret) {
                                this.$toast.clear();
                                this.$toast.success('修改成功')
                                setTimeout(() => {
                                    this.$router.history.go(-1);
                                }, 500);
                            }
                        })
                } else {
                    this.$http.tokiot.linkage.create(this.detail)
                        .then(ret => {
                            if (ret) {
                                this.$toast.clear();
                                this.$toast.success('创建成功')
                                setTimeout(() => {
                                    this.$router.history.go(-1);
                                }, 500);
                            }
                        })
                }
            },
            onDelete() {
                Dialog.confirm({
                    message: "确定删除吗"
                }).then(() => {
                    this.$http.tokiot.linkage.delete({id: this.linkageId})
                        .then(ret => {
                            if (ret) {
                                this.$toast.clear();
                                this.$toast.success('删除成功')
                                setTimeout(() => {
                                    this.$router.history.go(-1);
                                }, 500);
                            }
                        })
                })
            }

        },
        watch: {
            'detail.executeList'(executeList) {
            },
            'index'(index) {
                if (index >= 0) {
                    const {deviceId} = this.detail.executeList[index] || {}
                    if (deviceId) {
                        // const deviceActionList = this.actionMap[deviceId]
                        // !deviceActionList && this.loadActionList(deviceId)
                        this.loadActionList(deviceId)
                    }
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    @import "style/index.less";

    .form {
        background: #f3f3f3;
        padding: 5px 10px;
    }

    .title {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > .left {
            font-weight: 500;
            font-size: 20px;
            line-height: 1.5;
        }
        & > .right {
            color: #999999
        }
    }

    .action-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        font-size: 18px;
        line-height: 1.5;
    }

    .add-execute {
        margin-top: 1px;
        background: #ffffff;
        line-height: 35px;
        color: #1890ff;
        & > span {
            margin-left: 2px;
        }
    }

    .bg-write {
        background: #fff;
    }
</style>